"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Button = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var core_1 = require("@material-ui/core");
var Button_styles_1 = require("./Button.styles");
var enums_1 = require("../../enums");
var buttonHelper_1 = require("./buttonHelper");
exports.Button = function (_a) {
    var onClick = _a.onClick, _b = _a.name, name = _b === void 0 ? 'signa-button' : _b, children = _a.children, startIcon = _a.startIcon, endIcon = _a.endIcon, _c = _a.color, color = _c === void 0 ? enums_1.Color.primary : _c, _d = _a.size, size = _d === void 0 ? enums_1.Size.medium : _d, _e = _a.variant, variant = _e === void 0 ? enums_1.Variant.contained : _e, disabled = _a.disabled;
    var classes = Button_styles_1.useButtonStyles();
    var sizeClass = classes[size];
    var materialSize = size === enums_1.Size.fullWidth ? undefined : size;
    var classDisabled = variant === enums_1.Variant.contained
        ? buttonHelper_1.getContainerColorAndDisabledClassesMap(classes, color)
        : buttonHelper_1.getTextColorAndDisabledClassesMap(classes, color);
    return (react_1.default.createElement(core_1.Button, { classes: {
            root: classes.root,
            containedPrimary: buttonHelper_1.getContainedColorClassesMap(classes, color),
            containedSizeSmall: classes.containedSizeSmall,
            textPrimary: buttonHelper_1.getTextColorClassesMap(classes, color),
            textSizeSmall: classes.textSizeSmall,
            disabled: classDisabled,
        }, className: "" + sizeClass, disableElevation: true, color: "primary", variant: variant, "data-signa": name, onClick: onClick, startIcon: startIcon, endIcon: endIcon, size: materialSize, disabled: disabled },
        react_1.default.createElement("span", { className: classes.span }, children)));
};
